import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

function HeaderSection() {
  return (
    <div className="flex items-center justify-between py-4">
      <Skeleton className="w-80" variant="text" size="lg" />
      <div className="flex items-center">
        <Skeleton variant="circle" size="xs" />
        <Skeleton className="w-20 mx-4" variant="text" size="md" />
        <Skeleton className="w-36" variant="rectangle" size="sm" />
      </div>
    </div>
  );
}

export default observer(HeaderSection);
